export default {
  appVersion: '0.0.1',
  applicationKey: 'a0aaac84-a16e-47e8-a003-ef0e9a7841a0',
  applicationSecret: 'fWRFbwK13rfsjdk8hdtAYriu',
  sitekey: '6LfpuqkaAAAAAD_6jPIoNp_Q0gn5x_itmuia-4Mk',
  apiHost: 'http://localhost:9982'
}
